<script lang="ts">
	import CustomerOverview from '$lib/components/Customer/CustomerOverview.svelte';
	import CustomerNotLoggedIn from '$lib/components/Customer/CustomerNotLoggedIn.svelte';
	import { customer } from '$lib/store/customer.store';
	import { customerSessionDrawer } from '$lib/store/customerSessionDrawer.store';
	import { T, getTranslate } from '@tolgee/svelte';
	import type { PageData } from './$types';

	export let data: PageData;

	$: orders = data?.orders;

	const { t } = getTranslate();

	const handleOpenCustomerSessionDrawer = () => {
		customerSessionDrawer.setIsExpanded(true);
		customerSessionDrawer.setSessionType('login');
	};
</script>

{#if !$customer}
	<CustomerNotLoggedIn on:click={handleOpenCustomerSessionDrawer} />
{:else}
	<CustomerOverview {orders} />
{/if}
